import * as types from '../types';

const INITIAL_STATE = {
    isClosed: false,
    datePickerVisible: false,
    date: new Date(),
    user: '',
    listItem: [],
    ivcID: '',
    ivcValue: '',
    ivcUser: '',
    ivcDate: '',
    ivcDlvStamp: '', 
    ivcPaid: '',
    ivcAddress: '',
    ivcMobile: '',
    ivcNote: '',
    ivcMethod: '',
    ivcStatus: '',
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.UPDATE_INVOICE_ITEMS:
            return { ...state, ...action.payload };
        case types.RESET_INVOICE_ITEMS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
        
}